import authReducer from '../screens/auth/login/reducer';
import languageReducer from '../translation/reducer';
import loadingReducer from '../connected-components/loading/reducer';
import toastReducer from '../connected-components/toast/reducer';
import globalModalReducer from '../connected-components/globalModal/reducer';
import settingsReducer from '../screens/content/settings/reducer';
import chatReducer from '../screens/content/chat/reducer';

export default {
  auth: authReducer,
  lang: languageReducer,
  loading: loadingReducer,
  toast: toastReducer,
  globalModal: globalModalReducer,
  settings: settingsReducer,
  chat: chatReducer,
};
